import React from 'react';
import { Box } from '@mui/material';

interface AuthLayoutProps {
  children: React.ReactNode;
}

// The auth screens are designed in Inter (loaded in public/index.html); the rest
// of the app stays on the theme's Roboto.
export const AUTH_FONT = '"Inter", "Roboto", "Helvetica", "Arial", sans-serif';

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        backgroundColor: '#ffffff',
        fontFamily: AUTH_FONT,
        '& .MuiTypography-root, & .MuiInputBase-root, & .MuiButton-root, & .MuiAlert-root, & .MuiSelect-select':
          { fontFamily: AUTH_FONT },
      }}
    >
      {/* Left side - Background image with a light white wash (desktop only) */}
      <Box
        sx={{
          flex: 1,
          position: 'relative',
          backgroundImage: 'url(/login-bg.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          display: { xs: 'none', md: 'block' },
          '&::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.45)',
          },
        }}
      />

      {/* Right side - Form panel */}
      <Box
        sx={{
          width: { xs: '100%', md: 440 },
          flexShrink: 0,
          backgroundColor: '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: { xs: 2.5, sm: 5 },
          py: { xs: 6, md: 8 },
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 360 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AuthLayout;
